import styled from 'styled-components';

export const PageHeader = styled.div`
	max-height: 20rem;
	overflow: hidden;
`;
